export const SaleLotModalSection = {
  ACTIONS: "ACTIONS",
  AUCTION_PEN: "AUCTION_PEN",
  EIDS: "EIDS",
  GENERAL: "GENERAL",
  INTEGRATIONS: "INTEGRATIONS",
  INTERFACES: "INTERFACES",
  MARKING: "MARKING",
  MEDIA: "MEDIA",
  PICKUP_DETAILS: "PICKUP_DETAILS",
  SCANNING: "SCANNING",
  SELLING: "SELLING",
  VENDOR_SPLITS: "VENDOR_SPLITS",
  LEGACY_VENDOR_SPLITS: "LEGACY_VENDOR_SPLITS",
};

export const BusinessModalSection = {
  ADDRESS: "ADDRESS",
  GENERAL: "GENERAL",
  PROPERTIES: "PROPERTIES",
  BUYER_WAYS: "BUYER_WAYS",
  BUSINESS_MERGE_EVENTS: "BUSINESS_MERGE_EVENTS",
  EMAIL_RECIPIENTS: "EMAIL_RECIPIENTS",
  BUSINESS_RELATIONSHIPS: "BUSINESS_RELATIONSHIPS",
  FINANCE_AND_ACCOUNTING: "FINANCE_AND_ACCOUNTING",
  INTEGRATIONS: "INTEGRATIONS",
  TRANSACTIONS: "TRANSACTIONS",
};

export enum ConsignmentModalSection {
  ADVANCED_DRAFTING = "ADVANCED_DRAFTING",
  CARRIER_CHARGE = "CARRIER_CHARGE",
  DRAFTING = "DRAFTING",
  EIDS = "EIDS",
  FEES_AND_CHARGES = "FEES_AND_CHARGES",
  GENERAL = "GENERAL",
  MEDIA = "MEDIA",
  NLIS = "NLIS",
  PICKUP_DETAILS = "PICKUP_DETAILS",
  SALE_LOTS = "SALE_LOTS",
  NOTES = "NOTES",
  VENDOR_SPLITS = "VENDOR_SPLITS",
  LEGACY_VENDOR_SPLITS = "LEGACY_VENDOR_SPLITS",
  VENDOR_COMMISSION = "VENDOR_COMMISSION",
}

export enum ModalTypes {
  AllocatePenScanLots = "allocate-pen-scan-lots",
  AuditLog = "audit-log",
  BulkUpdateSaleLot = "bulk-update-sale-lot",
  BusinessLabel = "business-label",
  BulkUpdateBusiness = "bulk-update-business",
  BulkUpdateScanLabels = "bulk-update-scan-labels",
  BusinessReports = "business-reports",
  BuyerPaymentSummary = "buyer-payment-summary",
  BuyerSplit = "buyer-split",
  BillingDocumentActivity = "billing-document-activity",
  BillingDocumentReview = "billing-document-review",
  BusinessPayments = "business-payments",
  BusinessRelations = "business-relations",
  Comments = "comments",
  ConsignToSale = "consign-to-sale",
  Consignment = "edit-consignment",
  ConsignmentCarrierCharge = "edit-consignment-carrier-charge",
  CreateExternalAgentSaleFromSale = "create-external-agent-sale-from-sale",
  CreateSellViaExternalAgentSaleFromSale = "create-sell-via-external-agent-sale-from-sale",
  CreateIntegrationBusiness = "create-integration-business",
  DefaultBuyerWayProperty = "default-buyer-way-property",
  DeliverSaleLot = "deliver-sale-lot",
  DeliveryPen = "delivery-pen",
  DeliveryPenOwners = "delivery-pen-owners",
  DeploymentSaleOptions = "deployment-sale-options",
  EContract = "econtract",
  EIDReport = "eid-report",
  EditBidder = "edit-bidder",
  EditBillingDocument = "edit-billing-document",
  EditBillingRun = "edit-billing-run",
  EditBusiness = "edit-business",
  EditCheckpoint = "edit-checkpoint",
  EditIntegrationBusiness = "edit-integration-business",
  EditLedgerEntry = "edit-ledger-entry",
  EditLedgerAccount = "edit-ledger-account",
  EditMasterRule = "edit-master-rule",
  EditMasterRuleSet = "edit-master-rule-set",
  EditNomination = "edit-nomination",
  EditPayment = "edit-payment",
  EditReceivalLot = "edit-receival-lot",
  EditRule = "edit-rule",
  EditRuleSet = "edit-rule-set",
  EditPenScanLot = "edit-pen-scan-lot",
  EditScanningPen = "edit-scanning-pen",
  EditSaleLot = "edit-sale-lot",
  EditSaleLotCarrierCharge = "edit-sale-lot-carrier-charge",
  EditUserRole = "edit-user-role",
  EmailReportModal = "email-report",
  EmailReportJobModal = "email-report-job",
  ForceTransfer = "force-transfer",
  Filter = "filter",
  GlobalBusinessCreate = "global-business-create",
  ImportWeighLots = "import-weigh-lots",
  InlineCreateSaleLot = "inline-create-salelot",
  Interest = "generate-interest",
  InterestPreview = "interest-preview",
  ImportSummary = "import-summary",
  KillSheet = "kill-sheet",
  ManualAdjustmentForm = "manual-adjustment-form",
  ManualAdjustmentTable = "manual-adjustment-table",
  MapBusiness = "map-business",
  MergeSaleLot = "merge-sale-lot",
  MobileTransactionalCreateSaleModal = "mobile-transactional-create-sale",
  MoveScansToSale = "move-scans-to-sale",
  MoveToExistingRuleSet = "move-to-existing-rule-set",
  MultiSaleReports = "multi-sale-reports",
  NLISTransferReceipt = "nlis-transfer-receipt",
  RetainProceeds = "retain-proceeds",
  RuleTester = "rule-tester",
  RuleLibrary = "rule-library",
  PendingChanges = "pending-changes",
  RuleBook = "rule-book",
  Sale = "sale",
  SaleTypePicker = "sale-type-picker",
  SaleProgressOverview = "sale-progress-overview",
  SaleLot = "sale-lot",
  SaleStatus = "sale-status",
  Scan = "scan",
  ScanToPen = "scan-to-pen",
  SelectSyncData = "select-sync-data",
  SendVendorReports = "send-vendor-reports",
  SingleWeighSettings = "single-weigh-settings",
  SundryTemplate = "sundry-template",
  SplitSaleLot = "split-sale-lot",
  UnmergeBusiness = "unmerge-business",
  UpdateBuyer = "update-buyer",
  VendorSplitConsignment = "vendor-split-consignment",
  VendorSplitSaleLot = "vendor-split-salelot",
  VendorSplit = "vendor-split",
  WeightSettings = "weight-settings",
}

export type ModalTypeKey = (typeof ModalTypes)[keyof typeof ModalTypes];

export interface ModalAdapterProps {
  hash: {
    returnTo: string;
  } & Partial<Record<ModalTypeKey, string>>;
}
